import { render, staticRenderFns } from "./UserEditor.vue?vue&type=template&id=3326f396&scoped=true"
import script from "./UserEditor.vue?vue&type=script&lang=js"
export * from "./UserEditor.vue?vue&type=script&lang=js"
import style0 from "./UserEditor.vue?vue&type=style&index=0&id=3326f396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3326f396",
  null
  
)

export default component.exports